export default __webpack_public_path__ + "static/media/data-input.ecf5e6d8.svg";